import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CurrencyFormat from 'react-currency-format';
import styled from "styled-components";
import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
import TextInput from 'web/components/form-elements/TextInput';
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import CheckboxInput from 'web/components/form-elements/CheckboxInput';
import Button from 'web/components/Button';
import AlertModal from 'web/components/AlertModal';
import ReferenceNumberList from "web/components/ReferenceNumberList";
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import { buyerNeedCheckoutRejectApi, buyerNeedCheckoutAcceptApi, checkPromoIsValidApi } from 'redux/actions/checkout';

import { Tooltip } from "reactstrap";
import information from "web/assets/images/informationIcon.png";

import PaymentModule from '../PaymentModule';
// import DummyPallets from 'web/assets/images/card2.webp';
import DummyPallets from 'web/assets/images/pallet-home-image.jpg';
import { DateTimeWrapper1, InputWrapper, OrderDetail, PayWith, Address, ReviewOrder, Heading, AccountSection, AccountType, AccountDetail, Location, To, ReviewFooter, Des, CommentSection, } from '../checkOutStyle';
import { fetchLanguageContentNew } from 'redux/actions/language';

const ViewDetails = ({ callBackCheckoutFetchApi, checkoutPageData, props }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const urlObject = useSelector((state) => state.urlParameters.checkout);
  const fileUrl = process.env.REACT_APP_API_URL + '/user/image/';
  const token = localStorage.getItem('token');
  const [tooltip, setTooltip] = useState(false);

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()
  const [promoCodeDetails, setPromoCodeDetails] = useState()
  const [promoCodeErrorMessage, setPromoCodeErrorMessage] = useState('')

  const [alertType, setAlertType] = useState('')
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);


  const storedData = useSelector((state) => state.storedData.payload);

  useEffect(() => {
    if (checkoutPageData && checkoutPageData?.biddingStatus !== 'PENDING') {
      let obj = { selectedPage: undefined };
      dispatch({ type: "BIDS_PAGINATION", payload: obj });
    }
  }, [checkoutPageData])

  useEffect(() => {
    if (languageContentNew?.Pallets_Listing_Pages) setPageLanguageContents(languageContentNew.Pallets_Listing_Pages)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  const timeFormat = (timeString) => {
    let H = +timeString.substr(0, 2);
    let h = H % 12 || 12;
    let ampm = H < 12 ? ' AM' : ' PM';
    timeString = h + timeString.substr(2, 3) + ampm;
    return timeString;
  };
  const tConvert = (time) => {
    if (time) {
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) {
        time = time.slice(1); // Remove full string match value

        time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join("");
    }

  };

  const poNumber = () => {
    return <div>
      <Heading>{pageLanguageContents?.BuyModal[13]?.PONumber}</Heading>
      <TextInput
        name='poNumber'
        placeholder={pageLanguageContents?.BuyModal[13]?.PONumber}
        maxLength='20'
        showErrorMessages={true}
        disabled={checkoutPageData?.biddingStatus !== 'PENDING' ? true : false}
      />
    </div>
  }

  const referenceNumberDropDown = () => {
    return <div>
      <Heading>Order Reference Number</Heading>
      {/* editing is temporarily disabled for post load because of rec order logic issue */}
      <div>
        {/* {checkoutPageData?.ptPlusDetails?.orderRefNumber} -----  {checkoutPageData?.biddingStatus} */}
        {checkoutPageData?.ptPlusDetails?.orderRefNumber && checkoutPageData?.biddingStatus !== "AVAILABLE" ?
          <TextInput
            name='referenceNumber'
            placeholder={checkoutPageData?.ptPlusDetails?.orderRefNumber}
            maxLength='20'
            showErrorMessages={true}
            disabled={true}
          />
          :
          //<ReferenceNumberList disabled={true} callback={(refNumber) => { }} response={checkoutPageData} />
          <ReferenceNumberList callback={(refNumber) => { }} response={checkoutPageData} />
        }
      </div>
    </div>
  }
  const recurrenceTag = (responseObj) => {
    let dayOfWeekVal = ''
    if (responseObj?.pattern?.dayOfWeek) {
      if (responseObj.pattern.dayOfWeek === 'MONDAY') dayOfWeekVal = 'M'
      if (responseObj.pattern.dayOfWeek === 'TUESDAY') dayOfWeekVal = ' T'
      if (responseObj.pattern.dayOfWeek === 'WEDNESDAY') dayOfWeekVal = ' W'
      if (responseObj.pattern.dayOfWeek === 'THURSDAY') dayOfWeekVal = ' Th'
      if (responseObj.pattern.dayOfWeek === 'FRIDAY') dayOfWeekVal = ' F'
      if (responseObj.pattern.dayOfWeek === 'SATURDAY') dayOfWeekVal = ' Sat'
      if (responseObj.pattern.dayOfWeek === 'SUNDAY') dayOfWeekVal = ' Sun'
    }

    let daysOfWeek = []
    if (responseObj?.pattern && (responseObj?.pattern.type === "WEEKLY" || responseObj?.pattern.type === "RELATIVEMONTHLY" || responseObj?.pattern.type === 'MONTHLY')) {
      for (let i = 0; i < responseObj?.pattern.daysOfWeek.length; i++) {
        if (responseObj?.pattern.daysOfWeek[i] === 'MONDAY') daysOfWeek.push('M')
        if (responseObj?.pattern.daysOfWeek[i] === 'TUESDAY') daysOfWeek.push(' T')
        if (responseObj?.pattern.daysOfWeek[i] === 'WEDNESDAY') daysOfWeek.push(' W')
        if (responseObj?.pattern.daysOfWeek[i] === 'THURSDAY') daysOfWeek.push(' Th')
        if (responseObj?.pattern.daysOfWeek[i] === 'FRIDAY') daysOfWeek.push(' F')
        if (responseObj?.pattern.daysOfWeek[i] === 'SATURDAY') daysOfWeek.push(' Sat')
        if (responseObj?.pattern.daysOfWeek[i] === 'SUNDAY') daysOfWeek.push(' Sun')
      }
    }
    return <>
      <h6 className='recurrenceWrapper'>Recurring Order Requirements:</h6>
      <div className="flow-column">
        {responseObj?.pattern.type === "DAILY" && <p>Daily,&nbsp;{responseObj?.range.endAfterOccurrences ? "After " + responseObj?.range.endAfterOccurrences + " Recurrences" : <>{"Starting  " + moment(responseObj?.range.start).format("MM/DD/YYYY")}, {"Ending " + moment(responseObj?.range.endBy).format("MM/DD/YYYY")}</>}</p>}
        {responseObj?.pattern.type === "WEEKLY" && <p>Weekly,&nbsp;Every&nbsp;{daysOfWeek.join(',')},&nbsp;{responseObj?.range.endAfterOccurrences ? "After " + responseObj?.range.endAfterOccurrences + " Recurrences" : <>{"Starting  " + moment(responseObj?.range.start).format("MM/DD/YYYY")}, {"Ending " + moment(responseObj?.range.endBy).format("MM/DD/YYYY")}</>}</p>}
        {responseObj?.pattern.type === "MONTHLY" && <p>Monthly,&nbsp;{daysOfWeek.length !== 0 ? <>Every&nbsp;{daysOfWeek.join(',')}</> : <>{responseObj?.pattern.dayOfMonth}th</>}&nbsp;{responseObj?.range.endAfterOccurrences ? "After " + responseObj?.range.endAfterOccurrences + " Recurrences" : <>{"Starting  " + moment(responseObj?.range.start).format("MM/DD/YYYY")}, {"Ending " + moment(responseObj?.range.endBy).format("MM/DD/YYYY")}</>}</p>}
        {responseObj?.pattern.type === "RELATIVEMONTHLY" && <p>Monthly,&nbsp;{responseObj?.pattern.dayOfWeek && <>Every&nbsp;{dayOfWeekVal}</>}&nbsp;{responseObj?.range.endAfterOccurrences ? "After " + responseObj?.range.endAfterOccurrences + " Recurrences" : <>{"Starting  " + moment(responseObj?.range.start).format("MM/DD/YYYY")}, {"Ending " + moment(responseObj?.range.endBy).format("MM/DD/YYYY")}</>}</p>}
      </div>
    </>
  }

  const toolTipFunction = (infoTxt) => {
    return (
      <>
        <img
          id='invalidPromoToolTip'
          src={information}
          alt="information"
          style={{
            position: "relative",
            top: "-1px",
            marginLeft: "6px",
          }}
        />
        <Tooltip
          placement="right"
          isOpen={tooltip}
          target='invalidPromoToolTip'
          toggle={() => {
            setTooltip(!tooltip);
          }}
        >
          {infoTxt}
        </Tooltip>
      </>
    );
  };

  const promoButtonStyle = {
    background: 'linear-gradient(90deg, #55C416 1.12%, #367910 100%)',
    border: 'none',
    borderRadius: '4px',
    color: '#fff',
    margin: '0px'
  }
  const promoButtonStyleDisabled = {
    background: 'linear-gradient(90deg, #55C416 1.12%, #367910 100%)',
    border: 'none',
    borderRadius: '4px',
    color: '#fff',
    opacity: '0.5',
    margin: '0px'
  }

  const promoCodeSection = (propValues) => {
    return (
      <div style={{ margin: '22px 0' }}>
        <div style={{ display: 'grid', height: '38px', gridTemplateColumns: '4fr 1fr' }}>
          <div className={promoCodeErrorMessage !== '' && 'invalidPromoCodeStyle'} style={{ position: 'relative', marginRight: '15px' }}>
            <span style={{ pointerEvents: "auto", position: 'absolute', left: '-30px', top: '6px' }}>{toolTipFunction('Final promo amount will be calculated at order completion and processed as a rebate.')}</span>
            <TextInput
              name='checkoutPromoCode'
              maxLength='50'
              inputType='checkoutPagePromoCode'
              placeholder='Enter promo code'
              changeHandler={(value) => {
                setPromoCodeErrorMessage('')
                setPromoCodeDetails()
                const { setFieldValue } = props
                setFieldValue('promoCodeVaidated', false)
              }}
            />
            {props?.values?.promoCodeVaidated && <div style={{ position: 'absolute', fontSize: '13px', top: '35px', color: 'green', whiteSpace: 'nowrap' }}>Applied Successfully. {`(Rebate of $ ${promoCodeDetails?.calDiscountAmt?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")})`}</div>}
            {promoCodeErrorMessage !== '' && <div style={{ position: 'absolute', fontSize: '13px', top: '35px', color: '#ff0000', whiteSpace: 'nowrap' }}>Invalid promocode.</div>}
          </div>
          <button style={propValues?.checkoutPromoCode === '' ? promoButtonStyleDisabled : promoButtonStyle} disabled={propValues?.checkoutPromoCode === ''} onClick={() => checkPromoCodeIsValid(propValues)}>Apply</button>
        </div>
      </div>
    )
  }

  const checkPromoCodeIsValid = async (values) => {
    let apiResponse
    let data = {
      locationId: localStorage.getItem('locationID'),
      promoCode: values.checkoutPromoCode,
      productPrice: checkoutPageData?.bidPrice * checkoutPageData?.qty
    }
    apiResponse = await dispatch(checkPromoIsValidApi(data, token));
    if (apiResponse.calDiscountAmt) {
      const { setFieldValue } = props
      setFieldValue('promoCodeVaidated', true)
      setPromoCodeDetails(apiResponse)
    } else {
      setPromoCodeDetails()
      setPromoCodeErrorMessage(apiResponse.data?.message || apiResponse.message || 'Something went wrong, please try again after sometime.')
    }
  }

  const btnsAttach = () => {
    return (
      <>
        {checkoutPageData?.userType === "seller" && <small class="text-muted"><em>{pageLanguageContents?.BuyModal[14]?.Alert2}</em></small>}
        <>
          <div className="checkout-note">
            <Heading>Note to Seller</Heading>
            <div className="app-input-text">
              <textarea
                name="note"
                maxLength="500"
                onChange={(event) => {
                  const { setFieldValue } = props
                  setFieldValue('note', event.target.value)
                }}
              />
            </div>
          </div>
        </>
        {props.values?.achSelected &&
          <div>
            <CheckboxInput
              name="achAcknowledgeCheck"
              label="I authorize that you can withdraw funds from my ACH account. If it fails, you can use my credit card."
              handleSelect={() => { }}
            />
          </div>
        }
        <ReviewFooter>
          <Button
            type=''
            handleClick={() => declineFunction()}>
            {pageLanguageContents?.BuyModal[40]?.Reject}
          </Button>
          <Button
            type=''
            handleClick={() => acceptFunction()}
            disabled={(props.values?.achSelected && !props.values.achAcknowledgeCheck)}>
            {pageLanguageContents?.BuyModal[41]?.Accept}
          </Button>
        </ReviewFooter>
      </>
    );
  };

  const declineFunction = async () => {
    let response;
    let data = {
      authId: localStorage.getItem('authId'),
      bidId: urlObject?.id,
      comment: props.values?.note ?? null
    }
    response = await dispatch(buyerNeedCheckoutRejectApi(data, token));
    if (response?.success) {
      setAlertType('buyerNeedCheckoutReject')
      setModalContent(response?.data?.msg);
      setModalLink();
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  }

  const acceptFunction = async () => {
    let pageValues = props.values
    if (pageValues.checkoutPromoCode !== '' && !pageValues?.promoCodeVaidated) {
      setModalContent('Please validate the promocode.');
      setModalLink();
      toggleModal();
      return
    }
    if (pageValues?.achSelected && pageValues.achBackUpCard === '') {
      setModalContent('Please select a backup card for ACH mode of payment.');
      setModalLink();
      toggleModal();
      return
    }
    let response;
    let data = {
      authId: localStorage.getItem('authId'),
      locationId: localStorage.getItem('locationID'),
      bidId: urlObject?.id,
      orderRefNumber: props?.values?.referenceNumber ? props?.values?.referenceNumber : checkoutPageData?.ptPlusDetails?.orderRefNumber ? checkoutPageData?.ptPlusDetails?.orderRefNumber : '',
      promoCode: pageValues?.promoCodeVaidated ? pageValues.checkoutPromoCode : '',
      poNumber: pageValues?.poNumber,
      paymentMethod: pageValues?.paymentMethod,
      paymentMethodId: pageValues?.cardTypeRadio,
      comments: pageValues?.note,
      achPaymentMethodIds: null,
    }
    if (pageValues?.achSelected) {
      data.achPaymentMethodIds = [pageValues?.cardTypeRadio, pageValues?.achBackUpCard]
    }
    response = await dispatch(buyerNeedCheckoutAcceptApi(data, token));
    if (response?.success) {
      setAlertType('buyerNeedCheckoutAccept')
      setModalContent(response?.data?.msg);
      setModalLink();
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  }

  return (
    <>
      <div></div>
      <div className="checkout-cont">
        <Description>
          <div className="product-header-sec">
            <img
              src={RightArrow}
              alt="RightArrow"
              className="right-arrow"
            />
            <div class="community-name">
              {checkoutPageData?.biddingStatus === 'PENDING' ? <h4>{pageLanguageContents?.BuyModal[2]?.Checkout}</h4> : <p style={{ fontSize: '22px', fontWeight: 'bold' }}>Accepted</p>}
            </div>
          </div>
          {checkoutPageData?.biddingStatus === 'PENDING' && <p>Please review the requirements and accept. Upon acceptance, an order will be created.</p>}
        </Description>
        <PayWith>
          {checkoutPageData?.biddingStatus === 'PENDING' &&
            <>
              <Heading>
                {pageLanguageContents?.BuyModal[24]?.PayWith}
              </Heading>

              <AccountSection>
                <AccountType>
                  <PaymentModule
                    props={props}
                    checkoutPageData={checkoutPageData}
                    callBackCheckoutFetchApi={callBackCheckoutFetchApi}
                  />
                </AccountType>
              </AccountSection>
            </>
          }

          <Location>
            {checkoutPageData?.shippingMode === 'PICKUP' ?
              <Heading>
                {pageLanguageContents?.BuyModal[7]?.PickupLocation}
              </Heading>
              :
              <Heading>
                {pageLanguageContents?.BuyModal[6]?.DeliveryAddress}
              </Heading>
            }


            {props?.values?.city && props?.values?.city !== '' &&
              <>
                {checkoutPageData?.shippingMode === 'PICKUP' ?
                  <Address>
                    <p>{props?.values?.city},&nbsp;{stateConvert(props?.values?.state)}&nbsp;{props?.values?.zip}</p>
                    <p className='discalimerStyle'>Full address details will be displayed once the order is authenticated.</p>
                  </Address>
                  :
                  <Address>
                    <h2>{props?.values?.name}</h2>
                    <p>{props?.values?.line1}</p>
                    {props?.values?.line2 &&
                      <p>{props?.values?.line2}</p>}
                    <p>{props?.values?.city},&nbsp;{stateConvert(props?.values?.state)}&nbsp;{props?.values?.zip}</p>
                  </Address>}
              </>
            }


            <DateTimeWrapper1>
              <BidPriceSection>
                <div>
                  <Heading>
                    Bid Price
                  </Heading>
                  <InputWrapper>
                    <CurrencyFormat
                      value={checkoutPageData.bidPrice?.toFixed(2)}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"$"}
                    />
                  </InputWrapper>
                </div>

                {<div className='po-section'>
                  {poNumber()}
                </div>
                }
                {((checkoutPageData?.biddingStatus === 'PENDING'
                    || checkoutPageData?.biddingStatus === "ACCEPTED")
                  && storedData?.data?.isEnablePtPlusFeature
                  && !checkoutPageData?.orderReccurence) && <div className='order-ref-section'>
                    {referenceNumberDropDown()}
                </div>}
              </BidPriceSection>

              {/* bidPostLoad */}
              <DeliveryWindowSection>
                <div>
                  {checkoutPageData?.shippingMode === 'PICKUP' ?
                    <Heading>{pageLanguageContents?.BuyModal[8]?.PickupDate}</Heading>
                    :
                    <Heading>{pageLanguageContents?.BuyModal[11]?.DeliveryDate}</Heading>
                  }
                  <InputWrapper>{props?.values?.deliveryDateCheckout}</InputWrapper>
                </div>
                <div>
                  {checkoutPageData?.shippingMode === 'PICKUP' ?
                    <Heading>{pageLanguageContents?.BuyModal[9]?.PickupTime}</Heading>
                    :
                    <Heading>{pageLanguageContents?.BuyModal[12]?.DeliveryTime}</Heading>
                  }
                  <div className="d-flex align-items-center">
                    <InputWrapper>
                      {
                        timeFormat(checkoutPageData?.appointmentStartTime)}
                    </InputWrapper>
                    <To>
                      {pageLanguageContents?.BuyModal[10]?.To}
                    </To>
                    <InputWrapper>
                      {timeFormat(checkoutPageData?.appointmentEndTime)}
                    </InputWrapper>
                  </div>
                </div>
              </DeliveryWindowSection>

              {checkoutPageData?.dropLive === "LIVE" &&
                checkoutPageData?.shippingMode !== 'PICKUP' && <div className="row ">
                  <div className="col-12 align-items-end d-flex">
                    <p>The Requested delivery appointment is at {tConvert(checkoutPageData?.appointmentStartTime)}</p>
                  </div>
                </div>}
              {checkoutPageData?.orderReccurence && recurrenceTag(checkoutPageData?.orderReccurence)}
            </DateTimeWrapper1>

            {checkoutPageData?.bidderComment && (
              <CommentSection>
                <>
                  <div>
                    <h3>
                      {checkoutPageData?.bidderName}
                      <span>:</span>
                    </h3>
                    <p>
                      {checkoutPageData?.bidderComment ? checkoutPageData?.bidderComment : ""}
                    </p>
                  </div>
                </>
              </CommentSection>
            )}

          </Location>
        </PayWith>
        <ReviewOrder>
          <Heading>
            {pageLanguageContents?.BuyModal[29]?.ReviewOrder}
          </Heading>

          <OrderDetail>
            <div className="checkout-total">
              <div className="checkout-product-detail">
                <div className="checkout-product-img">
                  <div className="checkout-img p-2 text-center">
                    <img src={checkoutPageData?.postImageFiles ? `${fileUrl}${checkoutPageData?.postImageFiles[0].fileName}` : DummyPallets} />
                  </div>
                </div>
                <div className="checkout-product-desc">
                  <h2>{checkoutPageData?.postName}</h2>
                  <Des>{checkoutPageData?.postComment}</Des>
                </div>
              </div>
              <div className="checkout-count-table">
                <p>
                  <b>
                    {pageLanguageContents?.BuyModal[30]?.Quantity}
                    <span>:</span>
                  </b>
                  <span>
                    {checkoutPageData?.qty}&nbsp;
                  </span>
                </p>
                <p>
                  <b>
                    {pageLanguageContents?.BuyModal[33]?.Price_Pallet}
                    <span>:</span>
                  </b>
                  <span>
                    <CurrencyFormat
                      prefix={"$"}
                      value={checkoutPageData?.bidPrice?.toFixed(2)}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </span>
                </p>
                <p>
                  <b>
                    {pageLanguageContents?.BuyModal[34]?.Subtotal}
                    <span>:</span>
                  </b>
                  <span>
                    <CurrencyFormat
                      prefix={"$"}
                      value={(checkoutPageData?.qty * checkoutPageData?.bidPrice)?.toFixed(2)}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </span>

                </p>
                <p style={{ marginTop: '-6px' }}>
                  <small class="text-muted">
                    <em>*does not include tax or any other applicable charges.</em>
                  </small>
                </p>

                {checkoutPageData?.biddingStatus === 'PENDING' && !checkoutPageData?.orderReccurence && promoCodeSection(props.values)}

                {checkoutPageData?.biddingStatus === 'PENDING' && btnsAttach()}

                {checkoutPageData?.biddingStatus !== 'PENDING' &&
                  <p>
                    <b>{pageLanguageContents?.BuyModal[39]?.Status}<span>:</span></b>
                    <span><span className="greenStatus">{checkoutPageData?.biddingStatus}</span></span>
                  </p>
                }
              </div>
            </div>
          </OrderDetail>
        </ReviewOrder>
      </div>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=''
        content={modalContent}
        link={modalLink}
        alertType={alertType}
        callBackAlert={() => {
          // history.goBack();
          if (alertType === 'buyerNeedCheckoutReject') {
            let obj = {
              postType: "PostLoad",
              type: "postedNeeds",
              activePage: "PostLoad",
              activeSearch: 'Dashboard',
              expanded: 'panel1'
            }
            dispatch({ type: 'POST_LOAD_URL', payload: obj })

            history.push({ pathname: "/my-posted-pallet-needs", });
          } else if (alertType === 'buyerNeedCheckoutAccept') {
            let obj = { selectedTab: "PENDING", expanded: "sideBar" }
            dispatch({ type: 'ORDERS', payload: obj })
            history.push('/my-orders')
          }
        }}
        inventoryCallBackAlert={() => {
          let paginationObj = {
            selectedPage: 1,
          }
          dispatch({ type: 'BIDS_PAGINATION', payload: paginationObj })
          let obj = {
            postType: "PostInventory",
            type: "palletOffers",
            activePage: 'PostInventory',
            expanded: 'panel2'
          }
          dispatch({ type: 'CREATED_INVENTORY', payload: obj })

          history.push({
            pathname: "/my-posted-pallet-inventory",
          });
        }}
      />
    </>
  );
};

export default ViewDetails;
const DeliveryWindowSection = styled.div`
      display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 0 30px;
    @media (max-width:500px) {
      grid-template-columns: 1fr;
    }
`;
const BidPriceSection = styled.div`
      display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 30px;
    @media (max-width: 767px) {
      display: block
    }
    .po-section{
      width: 95%;
      margin-left: 5%;
    }
    .order-ref-section{
      width: 98%;
      margin-left: 2%;
    }
    @media (max-width: 767px) {
      .po-section, .order-ref-section{
        width: 100%;
        margin-left: 0;
      }
      .po-section .app-input-text{
        margin-bottom: 0px;
      }
    }
    
`;
const Description = styled.div`
  position: relative;
  padding-left: 62px;

  img.right-arrow {
    position: absolute;
    left: -36px;
  }
  .product-header-sec{
    margin-top: 10px;
    margin-bottom: 10px;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    @media (max-width: 767px) {
      grid-template-columns: 80% 1fr;
    }
  }
`;
